import { getAsset, getStyle } from '@utils/style';
import { ReactComponent as WarningIcon } from '@icons/warning.svg';
import { useTranslation } from 'react-i18next';
import { ReactElement } from 'react';

type LinkStatusType = 'error' | 'expired' | 'denied';

interface LinkStatusProps {
  type: LinkStatusType;
}

export const LinkStatus = ({ type }: LinkStatusProps): ReactElement => {
  const { t } = useTranslation();

  const messageKey =
    type === 'error' ? 'linkError' : type === 'expired' ? 'linkExpired' : 'consentDenied';

  return (
    <div className="link-status" style={{ borderColor: getStyle('ERROR_COLOR') }}>
      <div className="link-status-logo">
        <img
          src={getAsset('image', getStyle('LOGO', true))}
          alt="logo"
          className="link-status-img"
        />
      </div>

      <div className="link-icon-container">
        <WarningIcon className="warning-icon" style={{ color: getStyle('ERROR_COLOR') }} />
        <strong>{t(`common:${messageKey}`)}</strong>
      </div>

      <div className="link-separator" />
    </div>
  );
};
